import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { visibleSettings } from '@/components/settings/sections'
import { useTitle } from '@/lib/use-title'

export const Route = createFileRoute('/_app/settings/')({ component: SettingsIndex })

function SettingsIndex() {
  useTitle('Settings')
  const { me } = Route.useRouteContext()
  return (
    <>
      <div className="mb-5 lg:hidden">
        <h1 className="text-2xl font-semibold">Settings</h1>
      </div>
      <p className="mb-5 max-w-[65ch] text-[15px] text-muted-foreground">
        Everything here can be changed at any time. Quotes keep the prices and rules that applied
        when they were approved, so a change never alters a quote you have already sent.
      </p>
      <ul className="grid gap-3 sm:grid-cols-2">
        {visibleSettings(me).map((s) => (
          <li key={s.slug}>
            <Link
              to="/settings/$slug"
              params={{ slug: s.slug }}
              className="flex h-full items-start gap-3 rounded-xl border bg-card p-4 transition-colors hover:border-primary/40"
            >
              <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-foreground">
                <s.icon className="size-5" aria-hidden />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-semibold text-ink dark:text-foreground">{s.title}</span>
                <span className="mt-0.5 block text-sm text-muted-foreground">{s.description}</span>
              </span>
              <ChevronRight className="mt-2 size-4 shrink-0 text-muted-foreground" aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
    </>
  )
}
